import {
    Assets,
    Container,
    Sprite,
} from 'pixi.js';
import { IMG_SHURIKEN_BASE } from '../../CommonAssets';
import { Tween24, Ease24 } from 'tween24';

export class ShurikenObject extends Container {
    constructor(playerId, shurikenData){
        super();
        this.playerId = playerId;
        this.shurikenData = shurikenData;
        this.edges = [];
        this.rotateCount = 0;
        this.setData();
    }

    setData(){
        for(let i = 1; i <= 4; i++)
        {
            const effectId = parseInt(this.shurikenData[`mShurikenEffectId_0${i}`]);
            switch(effectId){
            case 0:
                this.edges.push(0);
                break;
            case 1:
                this.edges.push(2);
                break;
            case 2:
                this.edges.push(-1);
                break;
            default:
                this.edges.push(0);
                    
            }
        }

        this.edges.forEach((type, edge) => {
            const rotation = (90 * edge + 45) * Math.PI / 180;
            const edgeBase = new Sprite(Assets.get(IMG_SHURIKEN_BASE.name));
            if(type < 0){
                edgeBase.tint = 0x8642a4;
            }else if(0 < type){
                edgeBase.tint = 0xFFD700;
            }
            edgeBase.anchor.set(0.5, 1);
            edgeBase.width = edgeBase.width * 0.5;
            this.addChild(edgeBase);
            edgeBase.rotation = rotation;
        });
    }

    onRotate()
    {
        this.rotateCount = Math.round(Math.random() * 3);
        Tween24.tween(this, 3, Ease24._2_QuadInOut).rotation( ((this.rotateCount + 4 * 10) * 90) * Math.PI / 180).play();
    }

    getEdgeEffect(edge)
    {
        let rotatedEdge = edge - this.rotateCount;
        if(rotatedEdge < 0)
        {
            rotatedEdge += 4;
        }
        return this.edges[rotatedEdge];
    }

    select(isSelect){
        if(!this.coverLayer)
        {
            this.coverLayer = new Container;
            this.addChild(this.coverLayer);
            this.edges.forEach((type, edge) => {
                const rotation = (90 * edge + 45) * Math.PI / 180;
                const edgeBase = new Sprite(Assets.get(IMG_SHURIKEN_BASE.name));
                edgeBase.anchor.set(0.5, 1);
                edgeBase.width = edgeBase.width * 0.5;
                this.coverLayer.addChild(edgeBase);
                edgeBase.rotation = rotation;

                edgeBase.tint = 0x000000;
                edgeBase.alpha = 0.5;
            });
        }
        if(isSelect)
        {
            this.coverLayer.visible = true;
        }
        else
        {
            this.coverLayer.visible = false;
        }
    }
}
